import { DataEntry } from 'types/dataEntries';
import {
  KeyedStore,
  KeyedStoreSelector
} from 'types/stores';

export const createKeyedStoreSelector = <TParams, TKey, TData>(useStore: KeyedStore<TParams, TKey, TData>): KeyedStoreSelector<TParams, TData> =>
  (params: TParams | DataEntry<TParams>) =>
    useStore((state) => state.getEntry(params));
